import { render, staticRenderFns } from "./NoPlayerBanner.vue?vue&type=template&id=12e86b37&"
import script from "./NoPlayerBanner.vue?vue&type=script&lang=js&"
export * from "./NoPlayerBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports